import React, { useState } from 'react';
import Icon from '../Icon';
import clsx from 'clsx';

interface MenuContentProps {
  links: Link[];
  isHidden: boolean;
  open: boolean;
}

const MenuContent = ({ links, isHidden, open }: MenuContentProps) => {
  const elements = links.map((item, idx) => {
    return (
      <li key={idx} className="py-2">
        <a href={item.href} className="text-white text-ld leading-[24px]">
          {item.text}
        </a>
      </li>
    );
  });

  return (
    <div
      className={clsx(
        'overflow-hidden md:animate-none',
        open
          ? 'animate-[collapsibleOpen_0.3s_ease-in]'
          : 'animate-[collapsibleClose_0.3s_ease-in]'
      )}
    >
      <ul className={clsx('pb-4', isHidden && 'md:block hidden')}>
        {elements}
      </ul>
    </div>
  );
};

interface MenuLinksProps {
  menu: FooterSection | undefined;
}

export const LinkMenu = ({ menu }: MenuLinksProps) => {
  menu ??= {
    sectionTitle: '',
    sectionLinkList: [],
  };

  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isMenuHidden, setMenuHidden] = useState(true);

  const toggleVisibility = async () => {
    setMenuOpen(!isMenuOpen);

    if (isMenuOpen) {
      await new Promise((r) => setTimeout(r, 300));
      setMenuHidden(true);
    } else {
      setMenuHidden(false);
    }
  };

  return (
    <div>
      <div className="md:hidden block border-t border-solid border-gray-700 -mx-[10px] pt-4" />
      <h5
        className="text-white uppercase pb-3 flex justify-between"
        onClick={toggleVisibility}
      >
        {menu.sectionTitle}
        <Icon
          name="arrow-up"
          className={clsx(
            'md:!hidden transition-transform duration-300',
            isMenuOpen ? 'rotate-0' : 'rotate-180'
          )}
        />
      </h5>
      <MenuContent
        links={menu.sectionLinkList}
        isHidden={isMenuHidden}
        open={isMenuOpen}
      />
    </div>
  );
};
